module.exports = __webpack_public_path__ + "static/Andrew-a2c565d3edda9b729663178724436b11.jpg";